
import { ProjectTemplate } from "../types";

// Project templates data with realistic tasks and durations based on industry best practices
export const templates: ProjectTemplate[] = [

{
  id: 1,
  title: "Digital Transformation",
  tasks: [{
    name: "Initial Requirements Gathering",
    duration: 10
  }, {
    name: "Infrastructure Assessment",
    duration: 8
  }, {
    name: "Architecture Planning",
    duration: 15
  }, {
    name: "Resource Allocation",
    duration: 5
  }, {
    name: "Implementation Phase 1",
    duration: 20
  }, {
    name: "Quality Assurance",
    duration: 12
  }, {
    name: "Deployment & Training",
    duration: 10
  }, {
    name: "Post-Implementation Review",
    duration: 6
  }],
  milestones: 4,
  totalDuration: 86,
  description: "Standard template for digital transformation projects with predefined phases and milestones."
}, 
{
  id: 2,
  title: "IT Infrastructure Deployment",
  tasks: [{
    name: "Requirements Gathering",
    duration: 8
  }, {
    name: "Hardware Specification",
    duration: 10
  }, {
    name: "Network Design",
    duration: 12
  }, {
    name: "Security Planning",
    duration: 15
  }, {
    name: "Procurement Process",
    duration: 20
  }, {
    name: "Installation & Configuration",
    duration: 15
  }, {
    name: "Testing & Validation",
    duration: 10
  }, {
    name: "Documentation",
    duration: 8
  }, {
    name: "Handover & Training",
    duration: 6
  }],
  milestones: 6,
  totalDuration: 104,
  description: "Template for infrastructure deployment projects with hardware and software installation phases."
}, 
{
  id: 3,
  title: "Agile Software Development",
  tasks: [{
    name: "Product Backlog Creation",
    duration: 5
  }, {
    name: "Sprint Planning",
    duration: 3
  }, {
    name: "Design & Architecture",
    duration: 8
  }, {
    name: "Development Sprint 1",
    duration: 14
  }, {
    name: "Sprint Review & Demo",
    duration: 2
  }, {
    name: "Development Sprint 2",
    duration: 14
  }, {
    name: "QA Testing",
    duration: 8
  }, {
    name: "User Acceptance Testing",
    duration: 7
  }, {
    name: "Deployment Preparation",
    duration: 3
  }, {
    name: "Go-Live & Support",
    duration: 8
  }],
  milestones: 8,
  totalDuration: 72,
  description: "Template for managing agile software development with sprints and user stories."
}, 
{
  id: 4,
  title: "Application Managed Services",
  tasks: [{
    name: "Service Assessment & Planning",
    duration: 12
  }, {
    name: "Application Discovery & Documentation",
    duration: 15
  }, {
    name: "Service Level Agreement Definition",
    duration: 8
  }, {
    name: "Monitoring & Alerting Setup",
    duration: 10
  }, {
    name: "Backup & Recovery Implementation",
    duration: 12
  }, {
    name: "Performance Baseline Establishment",
    duration: 8
  }, {
    name: "Security Hardening & Compliance",
    duration: 15
  }, {
    name: "Patch Management Framework",
    duration: 10
  }, {
    name: "Incident Response Procedures",
    duration: 8
  }, {
    name: "Knowledge Transfer & Training",
    duration: 12
  }, {
    name: "Operational Handover",
    duration: 5
  }, {
    name: "Continuous Improvement Process",
    duration: 10
  }],
  milestones: 6,
  totalDuration: 125,
  description: "Template for implementing application managed services with comprehensive monitoring and support."
},
{
  id: 5,
  title: "Infrastructure Managed Services",
  tasks: [{
    name: "Infrastructure Audit & Assessment",
    duration: 15
  }, {
    name: "Service Scope Definition",
    duration: 10
  }, {
    name: "Monitoring Infrastructure Setup",
    duration: 12
  }, {
    name: "Asset Management Implementation",
    duration: 10
  }, {
    name: "Capacity Planning & Optimization",
    duration: 15
  }, {
    name: "Security Monitoring & Compliance",
    duration: 18
  }, {
    name: "Backup & Disaster Recovery Setup",
    duration: 20
  }, {
    name: "Change Management Process",
    duration: 8
  }, {
    name: "Service Catalog Development",
    duration: 12
  }, {
    name: "Automation Framework Implementation",
    duration: 25
  }, {
    name: "Staff Training & Certification",
    duration: 15
  }, {
    name: "Service Transition & Go-Live",
    duration: 8
  }],
  milestones: 7,
  totalDuration: 168,
  description: "Comprehensive template for infrastructure managed services covering all operational aspects."
}, 
{
  id: 6,
  title: "IT Network Managed Services",
  tasks: [{
    name: "Network Discovery & Documentation",
    duration: 15
  }, {
    name: "Network Performance Baseline",
    duration: 10
  }, {
    name: "Security Assessment & Hardening",
    duration: 18
  }, {
    name: "Network Monitoring Implementation",
    duration: 12
  }, {
    name: "Bandwidth Management & QoS",
    duration: 15
  }, {
    name: "Firewall & Security Configuration",
    duration: 20
  }, {
    name: "VPN & Remote Access Setup",
    duration: 12
  }, {
    name: "Network Backup & Recovery",
    duration: 10
  }, {
    name: "Incident Response & Escalation",
    duration: 8
  }, {
    name: "Change Control Procedures",
    duration: 8
  }, {
    name: "Documentation & Runbooks",
    duration: 12
  }, {
    name: "Service Transition & Support",
    duration: 10
  }],
  milestones: 6,
  totalDuration: 150,
  description: "Template for IT network managed services with focus on security and performance monitoring."
}, 
{
  id: 7,
  title: "Service Provider Network Managed Services",
  tasks: [{
    name: "Service Provider Network Assessment",
    duration: 20
  }, {
    name: "Multi-Vendor Environment Analysis",
    duration: 15
  }, {
    name: "Service Level Requirements Definition",
    duration: 12
  }, {
    name: "Network Operations Center Setup",
    duration: 25
  }, {
    name: "Service Assurance Implementation",
    duration: 18
  }, {
    name: "Fault Management & Correlation",
    duration: 20
  }, {
    name: "Performance Management System",
    duration: 22
  }, {
    name: "Customer Portal Development",
    duration: 30
  }, {
    name: "Billing & Revenue Assurance",
    duration: 25
  }, {
    name: "Service Provisioning Automation",
    duration: 35
  }, {
    name: "Compliance & Reporting Framework",
    duration: 15
  }, {
    name: "Service Launch & Customer Onboarding",
    duration: 12
  }],
  milestones: 8,
  totalDuration: 249,
  description: "Enterprise template for service provider network managed services with comprehensive service assurance."
},
{
  id: 8,
  title: "Marketing Campaign",
  tasks: [{
    name: "Market Research",
    duration: 12
  }, {
    name: "Campaign Strategy",
    duration: 10
  }, {
    name: "Creative Development",
    duration: 15
  }, {
    name: "Content Creation",
    duration: 20
  }, {
    name: "Media Planning",
    duration: 8
  }, {
    name: "Campaign Execution",
    duration: 30
  }, {
    name: "Performance Monitoring",
    duration: 45
  }, {
    name: "Analytics & Reporting",
    duration: 8
  }],
  milestones: 4,
  totalDuration: 148,
  description: "Template for planning and executing comprehensive marketing campaigns."
}, 
{
  id: 9,
  title: "Product Launch",
  tasks: [{
    name: "Market Analysis",
    duration: 15
  }, {
    name: "Product Strategy",
    duration: 12
  }, {
    name: "Competitive Analysis",
    duration: 10
  }, {
    name: "Pricing Strategy",
    duration: 7
  }, {
    name: "Go-to-Market Planning",
    duration: 12
  }, {
    name: "Marketing Materials",
    duration: 15
  }, {
    name: "Sales Enablement",
    duration: 10
  }, {
    name: "Pre-Launch Testing",
    duration: 14
  }, {
    name: "Launch Event",
    duration: 2
  }, {
    name: "Post-Launch Assessment",
    duration: 10
  }],
  milestones: 7,
  totalDuration: 107,
  description: "Structured template for successful product launches with go-to-market strategies."
}, 
{
  id: 10,
  title: "ERP Implementation",
  tasks: [{
    name: "Requirements Analysis",
    duration: 20
  }, {
    name: "System Selection",
    duration: 15
  }, {
    name: "Gap Analysis",
    duration: 10
  }, {
    name: "Data Migration Planning",
    duration: 15
  }, {
    name: "System Configuration",
    duration: 30
  }, {
    name: "Integration Development",
    duration: 25
  }, {
    name: "User Acceptance Testing",
    duration: 20
  }, {
    name: "User Training",
    duration: 15
  }, {
    name: "Go-Live Preparation",
    duration: 10
  }, {
    name: "Post-Implementation Support",
    duration: 30
  }],
  milestones: 6,
  totalDuration: 190,
  description: "Comprehensive template for enterprise resource planning system implementations."
}, 
{
  id: 11,
  title: "Construction Project",
  tasks: [{
    name: "Project Initiation",
    duration: 10
  }, {
    name: "Design & Engineering",
    duration: 30
  }, {
    name: "Permitting & Approvals",
    duration: 20
  }, {
    name: "Site Preparation",
    duration: 15
  }, {
    name: "Foundation Work",
    duration: 20
  }, {
    name: "Structural Framework",
    duration: 30
  }, {
    name: "Mechanical & Electrical",
    duration: 25
  }, {
    name: "Interior Finishes",
    duration: 40
  }, {
    name: "Final Inspections",
    duration: 10
  }, {
    name: "Project Closeout",
    duration: 15
  }],
  milestones: 8,
  totalDuration: 215,
  description: "Detailed template for managing construction projects from design to completion."
}, 
{
  id: 12,
  title: "Website Redesign",
  tasks: [{
    name: "Discovery & Research",
    duration: 10
  }, {
    name: "Information Architecture",
    duration: 8
  }, {
    name: "Wireframing",
    duration: 12
  }, {
    name: "Visual Design",
    duration: 15
  }, {
    name: "Content Creation",
    duration: 20
  }, {
    name: "Development",
    duration: 25
  }, {
    name: "QA Testing",
    duration: 10
  }, {
    name: "Client Review & Revisions",
    duration: 12
  }, {
    name: "Launch Preparation",
    duration: 5
  }, {
    name: "Post-Launch Support",
    duration: 15
  }],
  milestones: 5,
  totalDuration: 132,
  description: "Template for website redesign projects covering all phases from discovery to launch."
}, 
{
  id: 13,
  title: "Merger & Acquisition",
  tasks: [{
    name: "Target Identification",
    duration: 20
  }, {
    name: "Initial Due Diligence",
    duration: 30
  }, {
    name: "Valuation & Deal Structuring",
    duration: 25
  }, {
    name: "Negotiations",
    duration: 35
  }, {
    name: "Detailed Due Diligence",
    duration: 40
  }, {
    name: "Integration Planning",
    duration: 30
  }, {
    name: "Regulatory Approvals",
    duration: 45
  }, {
    name: "Closing Preparation",
    duration: 15
  }, {
    name: "Day 1 Integration",
    duration: 5
  }, {
    name: "Post-Merger Integration",
    duration: 90
  }],
  milestones: 7,
  totalDuration: 335,
  description: "Comprehensive template for managing complex merger and acquisition processes."
}, 
{
  id: 14,
  title: "New Product Development",
  tasks: [{
    name: "Idea Generation",
    duration: 15
  }, {
    name: "Concept Development",
    duration: 20
  }, {
    name: "Market Research",
    duration: 25
  }, {
    name: "Business Analysis",
    duration: 15
  }, {
    name: "Prototyping",
    duration: 30
  }, {
    name: "Technical Development",
    duration: 45
  }, {
    name: "Testing & Validation",
    duration: 30
  }, {
    name: "Production Planning",
    duration: 20
  }, {
    name: "Marketing Strategy",
    duration: 25
  }, {
    name: "Product Launch",
    duration: 15
  }],
  milestones: 6,
  totalDuration: 240,
  description: "Template for developing new products from ideation through to market launch."
}, 
{
  id: 15,
  title: "Office Relocation",
  tasks: [{
    name: "Needs Assessment",
    duration: 10
  }, {
    name: "Location Scouting",
    duration: 20
  }, {
    name: "Lease Negotiation",
    duration: 15
  }, {
    name: "Space Planning & Design",
    duration: 25
  }, {
    name: "IT Infrastructure Planning",
    duration: 20
  }, {
    name: "Vendor Selection",
    duration: 15
  }, {
    name: "Buildout & Renovation",
    duration: 45
  }, {
    name: "Furniture & Equipment",
    duration: 30
  }, {
    name: "Move Logistics Planning",
    duration: 15
  }, {
    name: "Relocation & Setup",
    duration: 10
  }],
  milestones: 5,
  totalDuration: 205,
  description: "Comprehensive template for planning and executing office relocations with minimal disruption."
}, 
{
  id: 16,
  title: "Compliance Implementation",
  tasks: [{
    name: "Regulatory Assessment",
    duration: 15
  }, {
    name: "Gap Analysis",
    duration: 20
  }, {
    name: "Policy Development",
    duration: 25
  }, {
    name: "Process Changes",
    duration: 30
  }, {
    name: "System Implementation",
    duration: 35
  }, {
    name: "Documentation",
    duration: 20
  }, {
    name: "Staff Training",
    duration: 15
  }, {
    name: "Internal Audit",
    duration: 10
  }, {
    name: "Remediation",
    duration: 20
  }, {
    name: "Certification",
    duration: 15
  }],
  milestones: 4,
  totalDuration: 205,
  description: "Template for implementing regulatory compliance programs across an organization."
}, 
{
  id: 17,
  title: "Data Migration",
  tasks: [{
    name: "Data Assessment",
    duration: 10
  }, {
    name: "Migration Strategy",
    duration: 15
  }, {
    name: "Data Mapping",
    duration: 20
  }, {
    name: "Data Cleansing",
    duration: 30
  }, {
    name: "Migration Tool Setup",
    duration: 15
  }, {
    name: "Test Migration",
    duration: 20
  }, {
    name: "Validation & Testing",
    duration: 25
  }, {
    name: "Performance Optimization",
    duration: 15
  }, {
    name: "Production Migration",
    duration: 10
  }, {
    name: "Post-Migration Support",
    duration: 20
  }],
  milestones: 5,
  totalDuration: 180,
  description: "Template for planning and executing complex data migration projects."
}, 
{
  id: 18,
  title: "Event Planning",
  tasks: [{
    name: "Event Definition",
    duration: 10
  }, {
    name: "Venue Selection",
    duration: 15
  }, {
    name: "Budget Planning",
    duration: 10
  }, {
    name: "Vendor Selection",
    duration: 20
  }, {
    name: "Marketing & Promotion",
    duration: 30
  }, {
    name: "Registration Management",
    duration: 45
  }, {
    name: "Content Planning",
    duration: 25
  }, {
    name: "Logistics Coordination",
    duration: 20
  }, {
    name: "On-Site Management",
    duration: 5
  }, {
    name: "Post-Event Analysis",
    duration: 10
  }],
  milestones: 6,
  totalDuration: 190,
  description: "Comprehensive template for planning and executing successful corporate events."
}, 
{
  id: 19,
  title: "Strategic Planning",
  tasks: [{
    name: "Environmental Analysis",
    duration: 15
  }, {
    name: "Internal Assessment",
    duration: 20
  }, {
    name: "Vision & Mission Review",
    duration: 10
  }, {
    name: "Goal Setting",
    duration: 15
  }, {
    name: "Strategy Formulation",
    duration: 25
  }, {
    name: "Action Planning",
    duration: 20
  }, {
    name: "Resource Allocation",
    duration: 15
  }, {
    name: "Implementation",
    duration: 90
  }, {
    name: "Monitoring & Evaluation",
    duration: 30
  }, {
    name: "Strategy Refresh",
    duration: 20
  }],
  milestones: 7,
  totalDuration: 260,
  description: "Template for developing and implementing organizational strategic plans."
}

];
